// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import lodash from 'lodash';
import VueLodash from 'vue-lodash'

import {
    STORE_ACTIONS,
} from '@/utils/constants';
// import { log } from '@/utils/common';
import App from './App.vue';
import router from './router';
import store from './store';
import mpnBaseComponentsPlugin from './plugins/mpn-base-components';
import '@/utils/publishedJs';

// 운영환경 빌드에서는 console.log 함수를 무효화 시킨다.
if (process.env.NODE_ENV === 'production') {
    window.console.log = () => {};
}

// 사파리에서 뒤로가기시 메모리 캐쉬로 부터 로딩 되는 것 방지
window.onpageshow = (event) => {
    console.log('EVENT::pageshow ', event);
    if (event.persisted) {
        console.warn('EVENT::pageshow ', 'event.persisted: true', 'will be reloaded');
        window.location.reload();
    }
};

Vue.config.productionTip = false;
smoothscroll.polyfill();

Vue.use(mpnBaseComponentsPlugin);
Vue.use(VueCookie);
Vue.use(VueLodash, { lodash: lodash });

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App,
    },
    beforeCreate() {
        console.log('main.js::beforeCreate');
        // this.$store.dispatch('ssoLogin');
        this.$store.dispatch('product/init');
        this.$store.dispatch(STORE_ACTIONS.RECOMMENDATION.INIT);
    },
    mounted() {
        console.log('main.js::mounted');
        this.$store.dispatch('common/set');
        this.$store.dispatch('notice/init');
    },
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js